// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useCurrentUser } from '@/authentication/hooks/use-current-user';
import {
  type FeatureFlags,
  getFeatureFlagsForUser,
} from '@/utils/feature-flags';

/**
 * React hook that provides feature flags for the current user's organization.
 *
 * This hook automatically determines which features are enabled based on the
 * current user's organization ID and user groups. System users bypass all
 * feature flags and have access to all features.
 *
 * @returns An object containing all feature flags and their enabled state
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const featureFlags = useFeatureFlags();
 *
 *   if (featureFlags.enableProjectWorkflows) {
 *     return <ProjectWorkflowsUI />;
 *   }
 *
 *   return <LegacyUI />;
 * }
 * ```
 */
export function useFeatureFlags(): FeatureFlags {
  const { user } = useCurrentUser();
  return getFeatureFlagsForUser(user.organization.id, user.userGroups);
}
